(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gripb-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gripb-catalog-filter')) {
  customElements.define('gripb-catalog-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.tabs = this.querySelector('[data-gb-catalog-tabs]');
      if (!this.tabs) return;
      this.buttons = Array.from(this.tabs.querySelectorAll('[data-gb-catalog-filter]'));
      this.products = Array.from(this.querySelectorAll('[data-gb-catalog-product]')).map(element => ({
        element,
        tags: (element.dataset.gbCatalogTags || '').split(/\s+/)
      }));
      this.status = this.querySelector('[data-gb-catalog-status]');
      this.controller = new AbortController();
      this.tabs.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-gb-catalog-filter]');
        if (button && this.tabs.contains(button)) this.filterProducts(button);
      }, { signal: this.controller.signal });
      this.filterProducts(this.buttons.find(button => button.getAttribute('aria-pressed') === 'true') || this.buttons[0], false);
      this.tabs.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    filterProducts(activeButton, announce = true) {
      if (!activeButton) return;
      const category = activeButton.dataset.gbCatalogFilter;
      let count = 0;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button === activeButton)));
      this.products.forEach(({ element, tags }) => {
        const visible = category === 'all' || tags.includes('gb-category-' + category);
        element.hidden = !visible;
        if (visible) count += 1;
      });
      if (announce && this.status) this.status.textContent = activeButton.textContent.trim() + ' · ' + count;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gripb-quick-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const wrapper = root.closest('.shopify-section');
    const grid = wrapper && wrapper.nextElementSibling;
    if (!grid) return;
    const abort = new AbortController();
    const events = {signal: abort.signal};
    const panel = root.querySelector('[data-gbq-panel]');
    const tabs = Array.from(root.querySelectorAll('[data-gbq-tab]'));
    const track = root.querySelector('[data-gbq-track]');
    const cards = Array.from(track.querySelectorAll('.gbq-card'));
    const shortcuts = Array.from(root.querySelectorAll('[data-gbq-shortcut]'));
    const navigation = root.querySelector('[data-gbq-navigation]');
    const previous = root.querySelector('[data-gbq-previous]');
    const next = root.querySelector('[data-gbq-next]');
    const position = root.querySelector('[data-gbq-position]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let frame = 0;
    let selected = cards[0];
    let moving = false;
    let settle = 0;
    root.querySelector('[data-gbq-count]').textContent = String(cards.length);
    root.querySelector('[data-gbq-total-count]').textContent = String(cards.length);
    shortcuts.forEach(link => { link.hidden = !cards.some(card => card.id === link.dataset.gbqShortcut); });
    const offsets = () => {
      const left = track.getBoundingClientRect().left;
      return cards.map(card => card.getBoundingClientRect().left - left + track.scrollLeft);
    };
    const visibleCount = () => Math.min(cards.length, mobile.matches ? 1 : 3);
    const lastIndex = () => Math.max(0, cards.length - visibleCount());
    const update = () => {
      frame = 0;
      if (panel.hidden || !track.clientWidth || !cards.length) return;
      const positions = offsets();
      active = positions.reduce((best, left, index) => Math.abs(left - track.scrollLeft) < Math.abs(positions[best] - track.scrollLeft) ? index : best, 0);
      active = Math.min(active, lastIndex());
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) active = lastIndex();
      const last = active + visibleCount();
      position.textContent = visibleCount() > 1 ? `${active + 1}–${last}` : String(active + 1);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      navigation.hidden = cards.length <= visibleCount();
      const selectedIndex = cards.indexOf(selected);
      if (!moving && (selectedIndex < active || selectedIndex >= last)) selected = cards[active];
      shortcuts.forEach(link => {
        if (link.dataset.gbqShortcut === selected.id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const schedule = () => { if (!frame) frame = window.requestAnimationFrame(update); };
    const goTo = (index, instant = false) => {
      if (!cards.length) return;
      const target = Math.max(0, Math.min(index, cards.length - 1));
      selected = cards[target];
      moving = true;
      window.clearTimeout(settle);
      settle = window.setTimeout(() => { moving = false; schedule(); }, 180);
      track.scrollTo({left: offsets()[target], behavior: instant || reducedMotion.matches ? 'instant' : 'smooth'});
      schedule();
    };
    const move = direction => goTo(Math.max(0, Math.min(lastIndex(), active + direction)));
    previous.addEventListener('click', () => move(-1), events);
    next.addEventListener('click', () => move(1), events);
    track.addEventListener('scroll', () => {
      schedule();
      window.clearTimeout(settle);
      settle = window.setTimeout(() => { moving = false; schedule(); }, 180);
    }, {passive: true, signal: abort.signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') goTo(0);
      else if (event.key === 'End') goTo(cards.length - 1);
      else move(event.key === 'ArrowRight' ? 1 : -1);
    }, events);
    shortcuts.forEach(link => link.addEventListener('click', event => {
      const index = cards.findIndex(card => card.id === link.dataset.gbqShortcut);
      if (index < 0) return;
      event.preventDefault();
      goTo(index);
    }, events));
    tabs[1].setAttribute('aria-controls', grid.id);
    grid.setAttribute('role', 'tabpanel');
    grid.setAttribute('aria-labelledby', tabs[1].id);
    function show(mode, remember = false) {
      const all = mode === 'all';
      root.dataset.gbqMode = mode;
      if (remember) {
        const url = new URL(location.href);
        url.searchParams.set('gbq', mode);
        history.replaceState(history.state, '', url);
      }
      panel.hidden = all;
      grid.hidden = !all;
      grid.style.display = all ? '' : 'none';
      tabs.forEach(t => { const isActive = t.dataset.gbqTab === mode; t.setAttribute('aria-selected', String(isActive)); t.tabIndex = isActive ? 0 : -1; });
      if (!all) schedule();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(tab.dataset.gbqTab, true), events);
      tab.addEventListener('keydown', e => { if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) { e.preventDefault(); const target = e.key === 'Home' ? tabs[0] : e.key === 'End' ? tabs[1] : tabs[1-i]; target.focus(); show(target.dataset.gbqTab, true); } }, events);
    });
    root.querySelector('[data-gbq-browse]').addEventListener('click', () => { show('all', true); tabs[1].focus(); tabs[1].scrollIntoView({block:'center', behavior: reducedMotion.matches ? 'instant' : 'smooth'}); }, events);
    const money = new Intl.NumberFormat(root.dataset.locale || 'ko', {style: 'currency', currency: root.dataset.currency || 'KRW'});
    const messages = JSON.parse(root.querySelector('[data-gbq-messages]').textContent);
    let purchasing = false;
    const productViews = [];
    const available = option => option?.dataset.available === 'true' && /^\d+$/.test(option.dataset.variantId || '');
    const setBusy = busy => {
      purchasing = busy;
      root.setAttribute('aria-busy', String(busy));
      productViews.forEach(view => view.update());
    };
    async function purchase(view, action, button) {
      if (purchasing) return;
      const options = view.options();
      const selected = action === 'single' ? options.filter(available) : options;
      if ((action === 'single' && selected.length !== 1) || !selected.length || !selected.every(available)) return;
      const items = selected.map(option => ({id: Number(option.dataset.variantId), quantity: 1}));
      const status = view.card.querySelector('[data-gbq-status]');
      const cartLink = view.card.querySelector('[data-gbq-view-cart]');
      setBusy(true);
      button.textContent = messages.adding;
      status.hidden = false;
      status.dataset.error = 'false';
      status.textContent = messages.adding;
      cartLink.hidden = true;
      let added = false;
      try {
        const response = await fetch(root.dataset.gbqAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          status.dataset.error = 'true';
          status.textContent = messages.add_error + (typeof result.description === 'string' ? ' ' + result.description : '');
          cartLink.hidden = false;
          return;
        }
        const returned = Array.isArray(result.items) ? result.items : [result];
        if (!items.every(item => returned.some(line => Number(line.variant_id || line.id) === item.id))) throw new Error('Incomplete cart response');
        added = true;
        status.textContent = messages.redirecting;
        const destination = root.dataset.gbqCartUrl + (action === 'cart' ? '' : '?review=1');
        window.location.assign(destination);
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = messages.network_error;
        cartLink.hidden = false;
      } finally {
        if (!added) setBusy(false);
      }
    }
    cards.forEach(card => {
      const lipSelect = card.querySelector('[data-gbq-lip]');
      const pairSelect = card.querySelector('[data-gbq-pair]');
      const buy = card.querySelector('[data-gbq-buy]');
      const add = card.querySelector('[data-gbq-add]');
      const single = card.querySelector('[data-gbq-single]');
      const stock = card.querySelector('[data-gbq-stock]');
      const view = {card, options: () => [lipSelect.selectedOptions[0], pairSelect.selectedOptions[0]], update: updateProducts};
      function updateProducts() {
        const [lip, pair] = view.options();
        if (!lip || !pair) return;
        const img = card.querySelector('[data-gbq-image]');
        img.src = lip.dataset.image; img.alt = lip.dataset.title;
        const pairImg = card.querySelector('[data-gbq-pair-image]');
        pairImg.src = pair.dataset.image; pairImg.alt = pair.dataset.title;
        card.querySelector('[data-gbq-lip-title]').textContent = lip.dataset.title;
        card.querySelector('[data-gbq-pair-title]').textContent = pair.dataset.title;
        card.querySelector('[data-gbq-lip-price]').textContent = money.format(Number(lip.dataset.cents) / 100);
        card.querySelector('[data-gbq-pair-price]').textContent = money.format(Number(pair.dataset.cents) / 100);
        card.querySelector('[data-gbq-link]').href = lip.dataset.url;
        card.querySelector('[data-gbq-pair-link]').href = pair.dataset.url;
        card.querySelector('[data-gbq-total]').textContent = money.format((Number(lip.dataset.cents) + Number(pair.dataset.cents)) / 100);
        const lipAvailable = available(lip), pairAvailable = available(pair);
        const both = lipAvailable && pairAvailable;
        buy.textContent = messages.buy_pair;
        add.textContent = messages.add_pair;
        buy.disabled = purchasing || !both;
        add.disabled = purchasing || !both;
        lipSelect.disabled = purchasing;
        pairSelect.disabled = purchasing;
        stock.hidden = both;
        if (!both) {
          const soldOut = [lip, pair].filter(option => !available(option)).map(option => option.dataset.title).join(', ');
          stock.textContent = soldOut + ' — ' + (lipAvailable || pairAvailable ? messages.stock_partial : messages.stock_all);
        }
        single.hidden = lipAvailable === pairAvailable;
        single.disabled = purchasing || lipAvailable === pairAvailable;
        const item = lipAvailable ? lip : pair;
        single.textContent = (lipAvailable ? messages.buy_lip_only : messages.buy_pair_only) + ' · ' + money.format(Number(item.dataset.cents) / 100);
      }
      function changeProducts() {
        card.querySelector('[data-gbq-status]').hidden = true;
        card.querySelector('[data-gbq-view-cart]').hidden = true;
        updateProducts();
      }
      lipSelect.addEventListener('change', changeProducts, events);
      pairSelect.addEventListener('change', changeProducts, events);
      buy.addEventListener('click', () => purchase(view, 'checkout', buy), events);
      add.addEventListener('click', () => purchase(view, 'cart', add), events);
      single.addEventListener('click', () => purchase(view, 'single', single), events);
      productViews.push(view);
      updateProducts();
    });
    window.addEventListener('pageshow', () => setBusy(false), events);
    root.addEventListener('shopify:block:select', event => {
      const index = cards.indexOf(event.target.closest('.gbq-card'));
      if (index < 0) return;
      show('guide');
      goTo(index, true);
    }, events);
    const observer = new ResizeObserver(schedule);
    observer.observe(track);
    mobile.addEventListener('change', schedule, events);
    instances.set(root, () => { abort.abort(); observer.disconnect(); window.cancelAnimationFrame(frame); window.clearTimeout(settle); instances.delete(root); });
    const params = new URLSearchParams(location.search);
    show(params.get('gbq') === 'guide' ? 'guide' : root.dataset.gbqFiltered === 'true' || params.get('gbq') === 'all' || Array.from(params.keys()).some(k => k === 'page' || k === 'sort_by' || k.startsWith('filter.')) ? 'all' : 'guide');
  }
  const initWithin = container => {
    if (container.matches?.('[data-gbq]')) init(container);
    container.querySelectorAll('[data-gbq]').forEach(init);
  };
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gbq]').forEach(root => instances.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gripb-subscription-pairs"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.gbsq-grid');
    const cards = [...track.querySelectorAll('.gbsq-card')];
    const prev = root.querySelector('[data-gbsq-prev]'), next = root.querySelector('[data-gbsq-next]');
    const position = root.querySelector('[data-gbsq-position]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    function refresh() {
      const first = Math.round(track.scrollLeft / step()) + 1;
      const visible = window.matchMedia('(max-width:749px)').matches ? 1 : 3;
      position.textContent = first + '–' + Math.min(cards.length, first + visible - 1) + ' / ' + cards.length;
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(delta) { track.scrollBy({left:delta * step(), behavior: reduced.matches ? 'auto' : 'smooth'}); }
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', refresh, {passive:true});
    track.addEventListener('keydown', e => {
      if (e.target !== track || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
      e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1);
    });
    root.querySelectorAll('.gbsq-chips a').forEach((link,i) => link.addEventListener('click', e => {
      if (!cards[i]) return;
      e.preventDefault(); track.scrollTo({left:cards[i].offsetLeft - cards[0].offsetLeft, behavior:reduced.matches ? 'auto' : 'smooth'});
    }));
    new ResizeObserver(refresh).observe(track);
    refresh();
    const money = new Intl.NumberFormat(root.dataset.locale || 'ko', {style: 'currency', currency: root.dataset.currency || 'KRW'});
    root.querySelectorAll('.gbsq-card').forEach(card => {
      const lipSelect = card.querySelector('[data-gbsq-lip]');
      const pairSelect = card.querySelector('[data-gbsq-pair]');
      function update() {
        const lip = lipSelect.selectedOptions[0], pair = pairSelect.selectedOptions[0];
        if (!lip || !pair) return;
        const img = card.querySelector('[data-gbsq-image]');
        img.src = lip.dataset.image; img.alt = lip.dataset.title;
        const pairImg = card.querySelector('[data-gbsq-pair-image]');
        pairImg.src = pair.dataset.image; pairImg.alt = pair.dataset.title;
        card.querySelector('[data-gbsq-pair-title]').textContent = pair.dataset.title;
        card.querySelector('[data-gbsq-link]').href = lip.dataset.url;
        card.querySelector('[data-gbsq-pair-link]').href = pair.dataset.url;
        card.querySelector('[data-gbsq-total]').textContent = money.format((Number(lip.dataset.cents) + Number(pair.dataset.cents)) / 100);
      }
      lipSelect.addEventListener('change', update);
      pairSelect.addEventListener('change', update);
      update();
    });
  }
  document.querySelectorAll('[data-gbsq]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-gbsq]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gripb-subscription"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target.closest?.('[data-gripb-subscription-products]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const products = document.getElementById('subscription-products');
  if (!products) return;
  event.preventDefault();
  products.focus({preventScroll: true});
  products.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  history.replaceState(history.state, '', '#subscription-products');
});
(() => {
  const instances = new WeakMap();
  const init = (root) => {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-routine-track]');
    const controls = root.querySelector('[data-routine-controls]');
    const cards = Array.from(root.querySelectorAll('[data-routine-card]'));
    if (!track || !controls || !cards.length) return;
    const previous = controls.querySelector('[data-routine-previous]');
    const next = controls.querySelector('[data-routine-next]');
    const current = controls.querySelector('[data-routine-current]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    let frame = 0;
    let active = 0;
    const positions = () => {
      const left = track.getBoundingClientRect().left;
      return cards.map(card => card.getBoundingClientRect().left - left + track.scrollLeft);
    };
    const update = () => {
      frame = 0;
      if (!mobile.matches) return;
      const offsets = positions();
      active = offsets.reduce((best, offset, index) => Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? index : best, 0);
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) active = cards.length - 1;
      current.textContent = String(active + 1);
      previous.disabled = active === 0;
      next.disabled = active === cards.length - 1;
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const move = (direction) => {
      if (!mobile.matches) return;
      const index = Math.max(0, Math.min(cards.length - 1, active + direction));
      track.scrollTo({left: positions()[index], behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    };
    const resize = () => {
      controls.hidden = !mobile.matches || cards.length < 2;
      if (!mobile.matches) track.scrollLeft = 0;
      schedule();
    };
    previous.addEventListener('click', () => move(-1), {signal: abort.signal});
    next.addEventListener('click', () => move(1), {signal: abort.signal});
    track.addEventListener('scroll', schedule, {passive: true, signal: abort.signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !mobile.matches) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, {signal: abort.signal});
    root.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('[data-routine-card]');
      const index = cards.indexOf(card);
      if (mobile.matches && index >= 0) track.scrollTo({left: positions()[index], behavior: 'instant'});
    }, {signal: abort.signal});
    mobile.addEventListener('change', resize, {signal: abort.signal});
    const observer = new ResizeObserver(resize);
    observer.observe(track);
    instances.set(root, () => {abort.abort();observer.disconnect();window.cancelAnimationFrame(frame);instances.delete(root);});
    resize();
  };
  const initWithin = (container) => {
    if (container.matches?.('[data-gb-routines]')) init(container);
    container.querySelectorAll('[data-gb-routines]').forEach(init);
  };
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gb-routines]').forEach(root => instances.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
